import { cn } from '@/shared/lib/cn';

/**
 * Activo / Inactivo pill badge used in the Configuración lists.
 * Matches the PowerApps look: green for Activo, amber for Inactivo.
 */
export function StatusBadge({
  status,
  className,
}: {
  status: string | null | undefined;
  className?: string;
}) {
  const isActive = (status ?? '').toLowerCase() === 'activo';
  return (
    <span
      className={cn(
        'inline-flex min-w-20 items-center justify-center rounded-md border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide',
        isActive
          ? 'border-emerald-300 bg-emerald-100 text-emerald-700'
          : 'border-amber-300 bg-amber-100 text-amber-700',
        className,
      )}
    >
      {status || 'Inactivo'}
    </span>
  );
}
